import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';


@Injectable({
  providedIn: 'root'
})
export class ApiResource {

  public token = `688787d8ff144c502c7f5cffaafe2cc588d86079f9de88304c26b0cb99ce91c6`;

  constructor(private api: ApiService) { }

  public obtenerHtmlPorUUID(uuid) {
    let microServicio = "/getPageDetails";
    let body = {
      uuid: uuid,
      token: this.token
    }
    return this.api.postMetodo(microServicio, body);
  }

  public buscar(name) {
    let microServicio = "/search";
    let body = {
      name: name,
      token: this.token
    }
    return this.api.postMetodo(microServicio, body);
  }

  public sendEmail(data) {
    let microServicio = "/sendEmail";
    let body = {
      ...data,
      token: this.token
    }
    return this.api.postMetodo(microServicio, body);
  }

  public obtenerActivos(page){
    let microServicio = "/getActives";
    let body = {
      page:page,
      token: this.token
    }
    return this.api.postMetodo(microServicio, body);
  }

  public filtrarActivos(data){
    let microServicio = "/getActives";
    let body = {
      ...data,
      token: this.token
    }
    return this.api.postMetodo(microServicio, body);
  }

  public obtnerPopups(){
    let microServicio = "/getPopups";
    let body = {
      token: this.token
    }
    return this.api.postMetodo(microServicio, body);
  }

  public obtenerLocations(data){
    let microServicio = "/getLocations";
    let body = {
      ...data,
      token: this.token
    }
    return this.api.postMetodo(microServicio, body);
  }

  public getNIU(data) {
    let microServicio = "/getNIU";
    let body = {
      ...data,
      token: this.token
    }
    return this.api.postMetodo(microServicio, body);
  }

  public validateToken(data) {
    let microServicio = "/validateToken";
    let body = {
      ...data,
      // token: this.token
    }
    return this.api.postMetodo(microServicio, body);
  }

  public documentosOnbase(data){
    let microServicio = "/documentosOnbase";

    let body = {
      ...data,
      // token: this.token
    }
    return this.api.postMetodoOnBase(microServicio, body);
  }


  public GetPromociones() {
    let microServicio = "/getPromociones";
    let body = {
      token: this.token
    }
    return this.api.postMetodo(microServicio, body);
  }
}